export const DashboardUserPermissions = {
  MayViewJobs: 'DB-MVJ',
  MayViewDrafts: 'DB-MVD',
  MayViewDashboard: 'DB-MVDB',
  MayCreateDrafts: 'DB-MCD',
};

export const DashboardAdminPermissions = {
  ...DashboardUserPermissions,
  MayDeleteDrafts: 'DB-MDD',
  MayViewAdminColumns: 'DB-MVAC',
};

export const DashboardPermissions = {
  ...DashboardAdminPermissions,
};
